<template lang="pug">
	div.default-modal
		.modal-header
			.modal-title Schedule {{ fieldLabel }} Update
			a.close(href="javascript:void(0);", @click="$emit('close')")
				i.la.la-times
		.modal-body.modal-form
			loading(:active.sync="busy", :is-full-page="true")
			.modal-body-inner
				ov-date-time-picker(v-model="datePicker", :single-date-only="true", :showTime="true", :minDate="nowDate", :fullWidth="true", label="Execute At")
				.form-group
					label Update to
					number-input(v-model="localNewValue" type="text" placeholder="Enter new value")
				.alert.alert-success.alert-dismissible.fade.show(v-if="showSavedAlert", role="alert")
					| Changes saved successfully. This scheduled change is now stored.
		.modal-footer
			.buttons.d-flex.justify-content-between.w-100
				.right-buttons
					button.btn.btn-danger(@click="cancelChange" v-if="scheduledChangeId")
						i.la.la-times
						| Cancel Schedule
				.left-buttons
					button.btn.btn-secondary(@click="$emit('close')") 
						| Close
					button.btn.btn-primary.ml-2(@click="saveChange" :disabled="busy || !canSave", v-b-tooltip.hover.bottom, :title="!canSave ? 'Please fill all fields' : ''" )
						span Save
          
</template>

<script>
import moment from "moment";
export default {
  name: "ScheduleFieldUpdateModal",

  props: {
    scheduledChangeId: { type: Number, default: null },
    entityType: { type: String, required: true },
    entityId: { type: Number, required: true },
    fieldName: { type: String, required: true },
    newValue: { type: String, default: "" },
    startAt: { type: String, default: "" },
    onUpdate: { type: Function, default: () => {} },
  },

  data() {

  return {
      datePicker: {
        timezone: 0,
        hideTZ: true,
        dateRange: {
          startDate: this.startAt ? moment(this.startAt) : moment().add(1, 'days').hour(0).minute(0).second(0),
          endDate: null,
        },
      },
      nowDate: null,
      busy: false,
      showSavedAlert: false,
      isCancelling: false,
      validDateRange: true,
      localNewValue: this.newValue,
      fieldLabel: ''
    };
  },
  computed:{
    canSave() {
      return !isNaN(this.localNewValue) && this.datePicker.dateRange.startDate;
    }
  },
  methods: {
    async saveChange() {
      if (this.busy || !this.canSave) return;

      try {
        this.busy = true;
        const formattedDate = moment(this.datePicker.dateRange.startDate).format("YYYY-MM-DD HH:mm:ss");

        const data = {
          id: this.scheduledChangeId,
          entity_type: this.entityType,
          entity_id: this.entityId,
          field_name: this.fieldName,
          new_value: this.localNewValue,
          start_at: formattedDate,
        };

        const response = await this.$ovReq.post('scheduledChange/save', data);
        const updatedData = (({ id, field_name, new_value, start_at }) => ({ id, field_name, new_value, start_at }))(response.entity);
        this.onUpdate(updatedData);

        this.showSavedAlert = true;
        setTimeout(() => {
          this.$emit("close");
        }, 2000);
        
        this.$ovNotify.success("Scheduled change saved");
      } catch (e) {
        this.$ovNotify.error("Failed to save scheduled change");
        console.error(e);
      } finally {
        this.busy = false;
      }
    },

    async cancelChange() {
      if (this.busy) return;
      
      if (!this.scheduledChangeId) {
        this.$ovNotify.warning("No scheduled change to cancel");
        return;
      }

      const confirmed = confirm("Are you sure you want to cancel this scheduled change?");
      if (!confirmed) return;
      
      try {
        this.busy = true;
        await this.$ovReq.patch(`scheduledChange/${this.scheduledChangeId}/cancel`);
        const canceledData = { id: this.scheduledChangeId, cancelled: true }
        this.onUpdate(canceledData);

        this.$ovNotify.success("Scheduled change cancelled");
        this.$emit('close');
      } catch (e) {
        this.$ovNotify.error("Failed to cancel scheduled change");
        console.error(e);
      } finally {
        this.busy = false;
      }
    },
  },

  mounted() {
    this.nowDate = moment().toDate();
    this.fieldLabel = this.fieldName; // default to field name
    switch (this.fieldName) {
      case 'daily_click_cap':
        this.fieldLabel = 'Daily Click Cap';
        break;
      case 'daily_impression_cap':
        this.fieldLabel = 'Daily Impression Cap';
        break;
      case 'daily_conversion_cap':
        this.fieldLabel = 'Daily Conversion Cap';
        break;
      case 'weekly_conversion_cap':
        this.fieldLabel = 'Weekly Conversion Cap';
        break;
      case 'daily_install_cap':
        this.fieldLabel = 'Daily Install Cap';
        break;
    }
  },
};
</script>
